import React from 'react';
import {connect, MapDispatchToProps, MapStateToProps} from 'react-redux';
import {Modals} from "../../component";
import {showApproveCaseModal} from "../../vendors/actions/modals";
import {approveCase} from "../../vendors/actions/case";

interface OwnProps {
    getUserInfo?: any

}

interface ConnectStateProps {

}

interface ConnectDispatchProps {
    showApproveCaseModal?: (boolean: boolean) => void;
    approveCase?: (case_uid: string) => void
}


const AcceptCaseModal = (props: any) => {

    const {caseApproveModal} = props.Modals,
        split = window.location.pathname.split('/'),
        case_uid = split[split.length - 1],
        closeModal = () => props.showApproveCaseModal(false),
        approveCase = () => props.approveCase(case_uid);

    return caseApproveModal ? (
        <Modals.Question
                        open={true}
                        icon={'lightbulb'}
                        cancelable={{
                            buttonTitle: 'Never Mind',
                            action: closeModal
                        }}
                        submit={{
                            buttonTitle: 'Approve',
                            action: approveCase
                        }}
                        description={`Please Approve that the work product and/or the services submitted by the lawyer meet the requirements outlined by you.`}/>
    ) : null;
};

type ConnectStateMapper = MapStateToProps<ConnectStateProps, OwnProps>

const mapStateToProps: ConnectStateMapper = (state: any) => {
    const {Modals} = state;
    return {Modals}
};

type ConnectDispatchMapper = MapDispatchToProps<ConnectDispatchProps, OwnProps>

const mapDispatchToProps: ConnectDispatchMapper = (dispatch: any) => {
    return {
        showApproveCaseModal: (data: boolean) => dispatch(showApproveCaseModal(data)),
        approveCase: (data: string) => dispatch(approveCase(data))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AcceptCaseModal);


